import React from 'react';
import { Link } from 'react-router-dom';

const HelpCenter: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 sm:py-14">
      <div className="container mx-auto px-4 max-w-2xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Help Center</h1>
        <p className="text-gray-600 mb-8">
          Quick answers for buyers and sellers on Buy Drop.
        </p>

        <div className="space-y-6">
          <section className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Selling</h2>
            <ul className="space-y-3 text-gray-700">
              <li>
                <Link to="/sell" className="text-green-700 font-medium hover:underline">
                  Sell on Buy Drop
                </Link>
                <span className="text-gray-500 text-sm block mt-0.5">
                  Download the BuyDrop Seller app, earnings, and how selling works.
                </span>
              </li>
              <li>
                <Link to="/sell#how-it-works" className="text-green-700 font-medium hover:underline">
                  How selling works
                </Link>
                <span className="text-gray-500 text-sm block mt-0.5">
                  Steps to download the seller app, create your store, and get paid.
                </span>
              </li>
            </ul>
          </section>

          <section className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Buying</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/money-back-guarantee" className="text-green-700 font-medium hover:underline">
                  BuyDrop Money Back Guarantee
                </Link>
                <span className="text-gray-500 text-sm block mt-0.5">
                  Shop with confidence. Get the item you ordered or your money back.
                </span>
              </li>
              <li>
                <Link to="/" className="text-green-700 font-medium hover:underline">
                  Browse listings
                </Link>
              </li>
              <li>
                <Link to="/my-orders" className="text-green-700 font-medium hover:underline">
                  My orders
                </Link>
              </li>
            </ul>
          </section>

          <section className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact</h2>
            <p className="text-gray-600 text-sm">
              Questions? Email{' '}
              <a href="mailto:support@buydrop.com" className="text-green-700 font-medium hover:underline">
                support@buydrop.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
